// extracted by mini-css-extract-plugin
module.exports = {"container":"FormTags_container__34G96","inlineContainer":"FormTags_inlineContainer__CJ_iN","label":"FormTags_label__294FW"};